<template>
  <div class="page-rule">
    <div class="content-wrap" ref="contentBScrollWrap">
      <div class="rule_box">
        <div class="tab_box" :style="{backgroundImage:'url(' + nowTab_bg + ')'}">
          <div @click="tabChange(1)"></div>
          <div @click="tabChange(2)"></div>
        </div>
        <div class="tab_content" v-show="nowTab === 1">
          <img src="../../assets/rule_img.png" class="rule_img">
          <div class="rule_text" v-html="ruleInfo"></div>
        </div>
        <div class="tab_content" v-show="nowTab === 2">
          <div class="award_box">
            <img src="../../assets/award_img.png">
            <div v-if="awardData.type === 1 || awardData.type === 2">
              <p class="award_title">奖品：{{awardData.prize_name}}</p>
              <p class="award_phone" v-if="awardData.phone">预留手机号：{{awardData.phone}}</p>
              <p class="award_phone" v-if="!awardData.phone">预留手机号：<span>未填写</span></p>
              <p class="award_tip">奖品将于活动结束后15个工作日内派送。请注意留意信息。</p>
              <button class="award_button" @click="toPhone" v-if="awardData.phone">修改</button>
              <button class="award_button" @click="toPhone" v-if="!awardData.phone">填写</button>
            </div>
            <div v-if="awardData.type === 3">
              <p class="award_title">奖品：{{awardData.prize_name}}</p>
            </div>
            <div v-if="!awardData.type">
              <p class="award_title">未中奖</p>
            </div>
          </div>
        </div>
      </div>
      <img src="../../assets/back.png" class="back_btn" @click="toback">
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'page-phone',
  data () {
    return {
      nowTab: 1,
      nowTab_bg: require('../../assets/rule_tab1.png'),
      ruleInfo: '',
      awardData: {}
    }
  },
  async created () {
    // this.preLoad()
  },
  async mounted () {
    this.$store.commit('setMusic', false) // 隐藏音乐播放按钮
    this.ruleInfo = this.$store.state.actInfo.content
    this.getAward()
    await this.setWxShare()
    // this.$stat({ event: 'phone_page' }) // 上报事件
  },
  methods: {
    async getAward () {
      try {
        const res = await this.$fetch.post('/lottery/my/prizes', { able_type: this.$store.state.actInfo.package_name })
        console.log(res)
        if (res.data.user_prizes && res.data.user_prizes.length > 0) {
          this.awardData.prize_name = res.data.user_prizes[0].prize_name
          this.awardData.type = res.data.user_prizes[0].type
        }
        if (res.data.user_address && res.data.user_address.phone) {
          this.awardData.phone = res.data.user_address.phone
        }
        console.log(this.awardData)
      } catch (error) {
        Toast('获取奖品失败')
        console.log('error', error)
      }
    },
    tabChange (id) {
      if (id === 1) {
        this.nowTab = 1
        this.nowTab_bg = require('../../assets/rule_tab1.png')
      } else {
        this.nowTab = 2
        this.nowTab_bg = require('../../assets/rule_tab2.png')
      }
    },
    toback () {
      this.$router.back(-1)
    },
    toPhone () {
      if (this.$store.state.overTime) {
        Toast('活动已结束')
      } else {
        this.$router.push({ path: '/phone' })
      }
    }
  },
  destroy () {
    console.log('我关闭了')
    this.$store.commit('setMusic', true) // 显示音乐播放按钮
  }
}
</script>

<style lang="scss" scoped>
.page-phone{
  height: 100vh;
}
.content-wrap{
  position: relative;
  width: 100%;
  height: 100vh;
  background:url('../../assets/bg.png') no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 4.7%;
  .rule_box{
    position: relative;
    width: 710px;
    height: 85%;
    overflow-y: auto;
    display:block;
    margin:auto;
    background-color: #fff;
    border-radius: 14px;
    .tab_box{
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 710px;
      // height: 8%;
      height: 105px;
      font-size: 0;
      div{
        display: inline-block;
        width: 50%;
        height: 100%;
      }
    }
    .tab_content{
      width: 94%;
      height: 88%;
      padding-top: 3.8%;
      overflow-y: auto;
      margin:auto;
      &:nth-child(2){
       background:#fffcf1;
      }
      .rule_img{
        width: 312px;
        height:49px;
        display: block;
        margin: auto;
        margin-bottom: 30px;
      }
      .rule_text{
        width: 100%;
        height: 88%;
        // margin-left: 5%;
        margin-top: 20px;
        font-size: 26px;
        color: #333;
        overflow-y: auto;
      }
      .award_box{
        background-color: #FFFCF2;
        position: relative;
        // width: 664px;
        width: 100%;
        height: 190px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 0;
        border: 2px solid #FFE09C;
        border-radius: 12px;
        margin:auto;
        margin-bottom: 18px;
        padding-left: 140px;
        img{
          width: 110px;
          height: auto;
          position: absolute;
          left: 14px;
          top: 40px;
        }
        p{
          display: block;
          width: 100%;
        }
        .award_title{
          color: #333;
          font-size: 32px;
          display: block;
          font-weight:bold;
        }
        .award_phone{
          color: #666;
          font-size: 26px;
          margin-top: 12px;
          width: 95%;
          span{
            color: #DE2F30;
          }
        }
        .award_tip{
          color: #666;
          font-size: 20px;
          margin-top: 12px;
          width: 95%;
        }
        .award_button{
          position: absolute;
          top: 49px;
          right: 42px;
          width: 100px;
          height: 48px;
          background-color: #DE2F30;
          color: #fff;
          font-size: 22px;
          line-height: 48px;
          border: none;
          border-radius: 8px;
        }
      }
    }
  }
  .back_btn{
    display: block;
    margin:auto;
    margin-top: 30px;
    width: 280px;
    height: 88px;
  }
}
</style>